export interface Exit {
    showExitModal: () => ExitType|false;
}

export enum ExitType {
    LOCK = 'lock',
    ACTIVE_MODIFICATION = 'active_modification',
}
